<template>	
	<div v-if="loading" v-loading="true" style="position: absolute; width: 32px; height: 32px; padding: 20px; margin: 8px;"></div>
	<transition v-else name="open-ticket" transition-mode="out-in">
		<TicketDetails :ticket="ticket" :showAssigned="true"/>
	</transition>
</template>

<script>
	
	import TicketDetails from "@/components/Projects/Project/TicketDetails";
	
	export default {
		
		components: { TicketDetails },
		
		computed: {
			
			ticket() {
				if (this.$store.getters.selectedTicket) {
					return this.$store.getters.selectedTicket;
				}
				return {};
			},
			
		},
		
		mounted() {
			this.$store.dispatch("refreshSelectedTicket", {
				id: this.$route.params.ticketId,
				callback: (success) => {
					this.loading = false;
				}
			});
		},
		
		data() {
			return {
				loading: true,
			}
		}
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/Projects/Project/TicketItemView.vue